import { gql, TypedDocumentNode } from '@common/hooks';
import {
  PaginatedShiftGapOpeningsQueryCgResponse,
  PaginatedShiftGapOpeningsQueryVariables,
  ShiftOpeningsFilterCreatorsQueryCgResponse,
  ShiftOpeningsFilterCreatorsQueryVariables,
  ShiftOpeningsFilterFacilitiesQueryCgResponse,
  ShiftOpeningsFilterFacilitiesQueryVariables,
  ShiftOpeningsFilterUnitsQueryCgResponse,
  ShiftOpeningsFilterUnitsQueryVariables,
} from '@common/graphql/schema';

export const SHIFT_GAP_OPENING_QUERY: TypedDocumentNode<
  PaginatedShiftGapOpeningsQueryCgResponse,
  PaginatedShiftGapOpeningsQueryVariables
> = gql`
  query PaginatedShiftGapOpenings(
    $limit: Int!
    $offset: Int!
    $filters: ShiftGapOpeningFilterInput
    $orderField: ShiftGapOpeningOrderField
    $orderDirection: OrderDirection
  ) {
    paginatedShiftGapOpenings(
      limit: $limit
      offset: $offset
      filters: $filters
      orderField: $orderField
      orderDirection: $orderDirection
    ) {
      shiftGapOpenings {
        id
        state
        stateChangedAt
        shiftGap {
          id
          startDatetime
          shiftDuration
          timeZone
          timeOfDay
          dayOfWeek
          organizationUnit {
            id
            name
            costCenter
          }
          organizationBusiness {
            id
            name
            tags
          }
          role {
            id
            abbreviation
          }
        }
        createdBy {
          id
          name
          systemUser
        }
        worksShift {
          id
          state
          worksShiftType
          perHourIncentivePay
          worker {
            id
            employeeId
            isInternal
            allowLists {
              id
              organizationUnit {
                id
              }
              staffingRequestAssignment {
                id
                staffingRequest {
                  id
                  billingRegularRate
                }
              }
            }
            worksUser {
              id
              name
            }
            workforceGroup {
              id
              name
            }
            homeUnit {
              id
              name
              costCenter
            }
          }
        }
      }
      totalCount
      exportMaxRowsAllowed
    }
  }
`;

export const SHIFT_OPENINGS_FILTER_UNITS: TypedDocumentNode<
  ShiftOpeningsFilterUnitsQueryCgResponse,
  ShiftOpeningsFilterUnitsQueryVariables
> = gql`
  query ShiftOpeningsFilterUnits {
    organizationUnits {
      id
      name
      costCenter
    }
  }
`;

export const SHIFT_OPENINGS_FILTER_FACILITIES: TypedDocumentNode<
  ShiftOpeningsFilterFacilitiesQueryCgResponse,
  ShiftOpeningsFilterFacilitiesQueryVariables
> = gql`
  query ShiftOpeningsFilterFacilities {
    organizationBusinesses {
      id
      name
      tags
    }
  }
`;

export const SHIFT_OPENINGS_FILTER_CREATORS: TypedDocumentNode<
  ShiftOpeningsFilterCreatorsQueryCgResponse,
  ShiftOpeningsFilterCreatorsQueryVariables
> = gql`
  query ShiftOpeningsFilterCreators($filters: ShiftCreatorFilterInput) {
    shiftCreators(filters: $filters) {
      id
      name
      systemUser
    }
  }
`;
